import { render, staticRenderFns } from "./ChangeClienteCuenta.vue?vue&type=template&id=19a97b60&scoped=true"
import script from "./ChangeClienteCuenta.vue?vue&type=script&lang=js"
export * from "./ChangeClienteCuenta.vue?vue&type=script&lang=js"
import style0 from "./ChangeClienteCuenta.vue?vue&type=style&index=0&id=19a97b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a97b60",
  null
  
)

export default component.exports